import { FixbotCTA } from '@ifixit/fixbot/fixbot-cta';
import initializeComponent from 'Shared/react-initialize';

function WikiFixbotCTACard({
   contentId,
   contentType,
   fixbotOrigin,
}: {
   contentId: number;
   contentType: 'wiki' | 'device';
   fixbotOrigin: string;
}) {
   const isDevice = contentType === 'device';
   return (
      // The top margin keeps the CTA from sitting flush against the content
      // above. Whatever comes next owns the gap below it: the repair shop
      // banner on device pages brings its own 24px, and the credits tighten
      // their own top margin when they land right under the CTA
      // (credit_author_team.phtml, translate_credit.phtml).
      <div className="mt-6">
         <FixbotCTA
            origin={fixbotOrigin}
            // Device/topic pages are wiki records, so FixBot looks them up as
            // type=wiki. The Device vs Wiki split only drives copy + analytics.
            contentType="wiki"
            contentId={contentId}
            analyticsCategory={isDevice ? 'Device' : 'Wiki'}
            translationNamespace={isDevice ? 'FixbotCTADevice' : 'FixbotCTAWiki'}
         />
      </div>
   );
}

initializeComponent('WikiFixbotCTACard', WikiFixbotCTACard);
